import { IPublicClientApplication, AccountInfo, InteractionRequiredAuthError, BrowserAuthError } from "@azure/msal-browser";
import { loginRequest } from "../features/auth/authConfig";
import { CONFIG } from "../config";

export async function getAccessToken(instance: IPublicClientApplication, account: AccountInfo) {
  try {
    const response = await instance.acquireTokenSilent({
      ...loginRequest,
      account,
    });
    return response.accessToken;
  } catch (error: any) {
    console.error("Token acquisition error:", error);

    if (
      error instanceof InteractionRequiredAuthError ||
      (error instanceof BrowserAuthError &&
        (error.errorCode === "monitor_window_timeout" ||
         error.errorCode === "token_renewal_error"))
    ) {
      console.warn("Token expired or renewal failed — redirecting to login");
      await instance.loginRedirect(loginRequest);
      return;
    }

    throw error;
  }
}

export function login(instance: IPublicClientApplication) {
  return instance.loginRedirect(loginRequest);
}

export async function logout(instance: IPublicClientApplication) {
  const account = instance.getActiveAccount();
  if (account) {
    const token = await getAccessToken(instance, account);
    await fetch(`${CONFIG.API_SERVER}/api/auth/logout`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
    }).catch(() => {});
  }

  instance.logoutRedirect();
}
